export default __webpack_public_path__ + "static/jmb_home-2fcf4e92a2b9f9b71d0b99b1b5705954.jpg";